import type { SVGProps } from 'react';

export function SparkleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M32 12L36 26L50 30L36 34L32 48L28 34L14 30L28 26L32 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M48 12L50 18L56 20L50 22L48 28L46 22L40 20L46 18L48 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M14 44L16 48L20 50L16 52L14 56L12 52L8 50L12 48L14 44Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
